import { render, staticRenderFns } from "./CollapsableComponent.vue?vue&type=template&id=a82106bc&scoped=true&"
import script from "./CollapsableComponent.vue?vue&type=script&lang=js&"
export * from "./CollapsableComponent.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableComponent.vue?vue&type=style&index=0&id=a82106bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82106bc",
  null
  
)

export default component.exports